export default {
	home: {
		afunOriginals: "AFun Gốc",
		slots: "Slot",
		liveCasino: "Casino Trực Tiếp",
		casualGames: "Trò Chơi Giải Trí",
		newReleases: "Mới Phát Hành",
		casinoTitle: "Casino",
		casinoDesc: "Tận hưởng trò chơi casino với hàng nghìn slot, dealer trực tiếp và trò chơi bàn",
		goToCasino: "Đến Casino",
		sportsTitle: "Thể Thao",
		sportsDesc: "Đặt cược Bóng Đá, Bóng Rổ, Quần Vợt và nhiều môn thể thao khác với tỷ lệ tốt nhất",
		goToSports: "Đến Thể Thao",
		liveTitle: "Trực Tiếp",
		liveDesc: "Hành động thời gian thực với dealer trực tiếp và trải nghiệm chơi tương tác",
		goToLive: "Đến Trực Tiếp",
		latestBetRace: "Cược & Đua Mới Nhất",
		sports: "Thể Thao",
		latestBets: "Cược Mới Nhất",
		game: "Trò Chơi",
		player: "Người Chơi",
		bet: "Cược",
		multiplier: "Hệ Số Nhân",
		profit: "Lợi Nhuận",
		top10Games: "Top 10 Trò Chơi",
		vip: "VIP",
		rewards: "Phần thưởng",
		affiliate: "Đại lý",
		promotion: "Khuyến mãi"
	},

	latestBetRace: {
		title: "Giải Lớn Bảng Xếp Hạng Trò Chơi",
		playerBetRank: "Cược Của Người Chơi Hôm Nay",
		playerWinRank: "Thắng Của Người Chơi Hôm Nay",
		gameBetRank: "Cược Trò Chơi Hôm Nay",
		gameWinRank: "Tiền Thưởng Trò Chơi Hôm Nay",
		player: "Người chơi",
		game: "Trò chơi",
		bet: "Đặt cược",
		profit: "Thắng",
		ratio: "Tỷ lệ thanh toán",
		totalBet: "Tổng tiền cược",
		totalReturn: "Tổng tiền thưởng",
		maxBet: "Cược tối đa",
		gameRatio: "% Tiền thưởng",
		noData: "Không có dữ liệu",
	},

	GameClassify: {
		casinoTitle: "Casino",
		casinoDesc: "Trải nghiệm các trò chơi casino từ các nhà cung cấp hàng đầu",
		casinoBtn: "Đến Casino",
		sportsTitle: "Thể Thao",
		sportsDesc: "Đặt cược Bóng đá, Cricket, NFL, Thể thao điện tử & hơn 80 môn thể thao",
		sportsBtn: "Đến Thể Thao",
		liveTitle: "Trực Tiếp",
		liveDesc: "Trải nghiệm thời gian thực cùng các dealer sống động",
		liveBtn: "Đến Trực Tiếp"
	}
}